import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { AiLabService, AiLabServiceImpl } from '@/services/ai-lab-service';
import { AiClmsService, AiClmsServiceImpl } from '@/services/ai-clms-service';
import { AiImageService, AiImageServiceImpl } from '@/services/ai-image-service';
import { AISearchModule } from '@/services/ai-search/ai-search.module';
import { HistoryModule } from '@/services/history/history.module';
import { aiTranslationModule } from '@/services/ai-translation/ai-translation.module';
import { AIDisclosureModule } from '@/services/ai-disclosure/ai-disclosure.module';

export const documentModule = new ContainerModule((bind) => {
    bind(AiLabService).to(AiLabServiceImpl);
    bind(AiClmsService).to(AiClmsServiceImpl);
    bind(AiImageService).to(AiImageServiceImpl);
    AISearchModule(bind);
    HistoryModule(bind);
    aiTranslationModule(bind);
    AIDisclosureModule(bind);
});
